export enum AmountTypeEnum {
    FinancialGuarantee = 1,
    Performance = 2,
    Maintenance = 3,
    LicensePermit = 4,
    RiskInsurance = 5,
    Other = 6
}
